// src/componentes/Barcode.jsx
import React from "react";
import Barcode from "react-barcode";

/**
 * Componente genérico de código de barras.
 * Usaremos CODE128 que es estándar y soporta cualquier string.
 */
const BarcodeWrapper = ({
  value,
  width = 2,
  height = 60,
  displayValue = false, // si quieres ver el texto debajo, ponlo en true
}) => {
  if (!value) return null; // si no hay valor, no renderizamos

  return (
    <Barcode
      value={value}
      width={width}
      height={height}
      displayValue={displayValue}
      margin={0}
      format="CODE128"
      background="#ffffff"
      lineColor="#000000"
    />
  );
};

export default BarcodeWrapper;